import { MagstimLocalisation } from '../Magstim.Localisation.js'

export function SetLanguage(lang, locale) {
  var jsLang = 'en';
  if ('en' === lang) {
    if ('us' === locale) {
      jsLang = 'en_us';
    }
  }
  else if ('de' === lang) {
    jsLang = 'de_de';
  }
  else if ('es' === lang) {
    jsLang = 'es_es';
  }
  else if ('fr' === lang) {
    jsLang = 'fr_fr';
  }
  else if ('zh' === lang) {
    jsLang = 'zh_cn';
  }
  localStorage.setItem('language', jsLang)
}

export function LocaliseRatingScale(allRatingScale) {
  if ((undefined !== allRatingScale) && (null !== allRatingScale)) {
    for (var x = 0; x < allRatingScale.length; x++) {
      const pt = allRatingScale[x];
      if ((undefined !== pt.ResourceId) && (null !== pt.ResourceId)) {
        const localised = CurrentLang()[pt.ResourceId];
        if ((undefined !== localised) && (null !== localised)) {
          // console.log(`Translating ${pt.ResourceId} resourceID to "${localised}"`);
          pt.name = localised;
        }
      }
    }
    allRatingScale.sort(function(lhs,rhs) { return lhs.Name.localeCompare(rhs.Name, undefined, { sensitivity: 'base' }); });
  }
}

export function CurrentLang() {

    let currentLang;
    // eslint-disable-next-line no-undef
    switch(localStorage.getItem('language')) {
        case 'de_de':
            currentLang = MagstimLocalisation.de_de;
          break;
        case 'en':
            currentLang = MagstimLocalisation.en;
          break;
          case 'es_es':
            currentLang = MagstimLocalisation.es_es;
          break;
        case 'fr_fr':
            currentLang = MagstimLocalisation.fr_fr;
          break;
        case 'zh_cn':
            currentLang = MagstimLocalisation.zh_cn;
          break;
        case 'en_us':
        default:
            currentLang = MagstimLocalisation.en_us;
      }

    return currentLang
}